// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-align/es/index.js
// module id = 395
// module chunks = 0